import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2023/6E/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2023/6E/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2023/6E/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2023/6E/4.jpg';
// import p5 from 'assests/Photos/ClassAssembly/2023/6E/5.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly2023';

const ClassAssembly6E2023 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6E/1.webp`;
const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6E/2.webp`;
const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6E/3.webp`;
const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6E/4.webp`;
const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6E/5.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
          src: p5,
          source: p5,
          rows: 1.5,
          cols: 2,
        },
   
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      World Anthropology Day 
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/>
         Class: 6E     Date: 14 FEBRUARY 2024

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
        “History is, strictly speaking, the study of questions; the study of answers belongs to Anthropology”
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        World Anthropology Day is celebrated every year to emphasize the significance of Anthropology in   
       understanding the World. The students of Class 6E presented their assembly on this occasion to provide an 
       insight into the myriad cultures and traditions around the globe. The assembly commenced with a thought 
       for the day followed by a brief introduction of the topic. 
        <br/>
        It also featured the vibrant and energetic group dance. The students, adorned in colourful attire, created a lively atmosphere as they moved in rhythmic patterns. They showcased the different cultures through different costumes on the ramp. An informative quiz was conducted on the topic. The assembly made a strong impact and conveyed a message that Anthropology is the science which tells us that people all over the world are the same.
        <br/>
        The assembly was well appreciated by the honourable Principal, teachers and all the students. 
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Let’s flaunt our yellow dresses, share yellow sweets, fly kites and worship Goddess Saraswati! Let's shed lethargy and welcome the spring season. Happy Basant Panchami!”

<br/>
        </Typography> */}

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <SidebarArticles />
             </Box>
          
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly6E2023;